module.exports = __webpack_public_path__ + "img/nav-design-coloredstones@2x.44faf4d.jpg";